import { pin_row } from "@microchip/pin-standard";
import { PinsData } from "@microchip/melody-automodule-interface/lib/src/pins";
import {
    AppModel,
    PinsLogic,
} from "@microchip/melody-automodule-interface/lib/src/types";
import { getPinsDataFromFile, getPinsLogicFromFile } from "../getUserData";

const mockPinsLogic = (getPinsData: GetPinsData): PinsLogic => {
    const getCompletePinData = (appModel: AppModel): any => {
        return {};
    };
    const getRowData = (appModel: AppModel, rowData: pin_row): pin_row => {
        return rowData;
    };
    return {
        getCompletePinData: getCompletePinData,
        getRowData: getRowData,
        getPinsData: getPinsData,
    };
};

type GetPinsData = typeof getPinsData;
export const getPinsData = (): PinsData => getPinsDataFromFile() ?? { rows: [] };

export const getPinsLogic = (): PinsLogic => {
    const pinsLogic = getPinsLogicFromFile();
    if (pinsLogic) {
        return {
            ...pinsLogic,
            getPinsData: getPinsData,
        };
    } else {
        return mockPinsLogic(getPinsData);
    }
};
